import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkIcon", "activeIllustration", "inactiveIllustration"]

  closeSiblings({ currentTarget }) {
    for (const detail of this.element.children) {
      if (detail.firstElementChild !== currentTarget) {
        this.dispatch("sibling-opened", { target: detail, bubbles: false })
      }
    }
  }

  handleOptionSelect(event) {
    const detailsElement = event.currentTarget.closest("details")
    const checkIcon = this.checkIconTargets.find((target) => detailsElement.contains(target))
    const activeIllustration = this.activeIllustrationTargets.find((target) => detailsElement.contains(target))
    const inactiveIllustration = this.inactiveIllustrationTargets.find((target) => detailsElement.contains(target))
    const allDetails = Array.from(detailsElement.parentElement.querySelectorAll("details"))

    // remove checks and glows and make all illustrations inactive
    this.checkIconTargets.forEach((icon) => icon.classList.add("invisible"))
    this.activeIllustrationTargets.forEach((icon) => icon?.classList?.add("hidden"))
    this.inactiveIllustrationTargets.forEach((icon) => icon?.classList?.remove("hidden"))
    allDetails.forEach((details) => details.classList.remove("persist-glow"))

    // add check, glow and active illustration to selected option
    checkIcon.classList.remove("invisible")
    activeIllustration.classList.remove("hidden")
    inactiveIllustration.classList.add("hidden")
    detailsElement.classList.add("persist-glow")

    this.closeSiblings(event)
  }
}
